import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';

import { RouterService } from '@bca-core/services/router.service';
import { Route } from '@bca-shared/models/_enums';
import { IRootState } from '@bca-store/store.reducers';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, take, tap } from 'rxjs/operators';

@Injectable()
export class ConfirmationGuard implements CanActivate {
  constructor(
    private _store$: Store<IRootState>,
    private _routerService: RouterService
  ) {}

  canActivate(): Observable<boolean> {
    return this._store$.pipe(
      select(({ confirmation }) => confirmation.transaction),
      take(1),
      map(transaction => transaction != null),
      tap((paymentStarted: boolean) => {
        if (!paymentStarted) {
          this._routerService.navigateTo(Route.AGREEMENT);
        }
      })
    );
  }
}
